"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    { path: "/", component: () => Promise.resolve().then(() => __importStar(require("../pages/HomePage/index.vue"))) },
    { path: "/nodeView", component: () => Promise.resolve().then(() => __importStar(require("../pages/NodeView/index.vue"))) },
    {
        path: "/productionInfo",
        component: () => Promise.resolve().then(() => __importStar(require("../pages/ProductionInfo/index.vue"))),
    },
    {
        path: "/deviceInfo",
        component: () => Promise.resolve().then(() => __importStar(require("../pages/DeviceInfo/index.vue"))),
    },
    {
        path: "/dictionaries",
        component: () => Promise.resolve().then(() => __importStar(require("../pages/Dictionaries/index.vue"))),
    },
    {
        path: "/Mbom",
        component: () => Promise.resolve().then(() => __importStar(require("../pages/Mbom/index.vue"))),
    },
    {
        path: "/productionInfoList",
        name: "productionInfoList",
        component: () => Promise.resolve().then(() => __importStar(require("../pages/ProductionInfoList/index.vue"))),
    },
    {
        path: "/deviceInfoList",
        name: "deviceInfoList",
        component: () => Promise.resolve().then(() => __importStar(require("../pages/DeviceInfoList/index.vue"))),
    },
];
